module.exports = __webpack_public_path__ + "static/media/venus.583bb011.svg";